import type {
  RatingScaleQuestion,
  NPSSurveyQuestion,
  SurveyHandler,
  SurveyError,
} from 'src/types/survey';
// @ts-expect-error - TS2614 - Module '"src/api-parsers/events"' has no exported member 'Answer'. Did you mean to use 'import Answer from "src/api-parsers/events"' instead?
import type {Answer} from 'src/api-parsers/events';

import * as React from 'react';
import range from 'lodash/range';
import get from 'lodash/get';
import {lerp} from 'src/utils';

import css from './rating.css';


type Props = {
  data: RatingScaleQuestion | NPSSurveyQuestion;
  response?: Answer;
  handleNext: SurveyHandler;
  type: string;
  brandColor: string;
  currentError: SurveyError;
};
type State = {
  hasSelected: boolean;
  selectedValue: string | null | undefined;
};

export default class RatingSurveyQuestion extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasSelected: false || props.response != null,
      // @ts-expect-error - TS2873 - This kind of expression is always falsy.
      selectedValue: null || get(props, 'response.moduleValue'),
    };
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<Props, State, any>'.
  render(): React.ReactElement<React.ComponentProps<'div'>> {
    const {data, handleNext, type, brandColor, currentError} = this.props;

    const selectedValue = this.state.selectedValue;

    return (
      <div className={css.rating}>
        <p className={css.ratingQuestionText}>
          {data.question}
          {data.required && ' *'}
        </p>
        {currentError && (
          <p className={css.ratingSurveyError}>{currentError.message}</p>
        )}
        <div className={css.ratingBox}>
          {range(data.minRating, data.maxRating + 1).map((value) => (
            <span
              className={
                // @ts-expect-error - TS2367 - This comparison appears to be unintentional because the types 'string | null | undefined' and 'number' have no overlap.
                selectedValue === value
                  ? css.selectedRatingSegment
                  : css.ratingSegment
              }
              key={value}
              // @ts-expect-error - TS2322 - Type '(evt: Event) => void' is not assignable to type 'MouseEventHandler<HTMLSpanElement>'. | TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
              onClick={this.handleSelect.bind(this, value)}
            >
              {value}
            </span>
          ))}
        </div>
        <div className={css.labelBox}>
          <span className={css.ratingLabel}>{data.minText}</span>
          <span className={css.ratingLabelRight}>{data.maxText}</span>
        </div>
        {!!this.state.hasSelected && (
          <button
            className={css.nextButton}
            style={{
              backgroundColor: brandColor,
              borderColor: brandColor,
            }}
            // @ts-expect-error - TS2322 - Type '(evt: Event) => void' is not assignable to type 'MouseEventHandler<HTMLButtonElement>'.
            onClick={(evt: Event) => {
              evt.preventDefault();
              handleNext(this.state.selectedValue);
            }}
          >
            Next
          </button>
        )}
      </div>
    );
  }

  handleSelect(value: string, evt: Event) {
    const {type, handleNext} = this.props;
    evt.preventDefault();
    if (type === 'nps') {
      this.setState({
        hasSelected: true,
        selectedValue: value,
      });
    } else {
      handleNext(value);
    }
  }
}

// Made with ♥️ by SpacedOut Labs
